var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wc__timer"},[(_vm.showTimer)?[_c('racing-flag-icon'),_c('span',[_vm._v(_vm._s(_vm.formattedTime))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }